import { STAGE } from '../stage.js';
import { packageExtras } from './format.js';
import { heightAt } from './heights.js';
import { addBoxSight, emptySight, mergeSight, sightGround, } from './measure.js';
import { propBox } from './props.js';
/**
 * What hides a model in a package's world (ADR-053): its props, from the platform models' boxes as
 * they stand, and every GLB the media worker measured with a sight profile (`GlbMeasure.sight`).
 * `complete` is false when a GLB was measured before generator v6: its scenery is then unknown, and
 * only the props count until the package is uploaded again.
 */
export function packageSight(pkg, measured) {
    const profile = emptySight();
    for (const prop of packageExtras(pkg).props) {
        for (const place of prop.at) {
            const box = propBox(prop, place);
            if (box)
                addBoxSight(profile, box);
        }
    }
    let sight = profile;
    let complete = measured !== undefined && measured !== null;
    for (const name of pkg.terrain.glb) {
        const glb = measured?.glbs[name];
        if (glb?.sight === undefined) {
            complete = false;
            continue;
        }
        sight = mergeSight(sight, glb.sight);
    }
    return { sight, complete };
}
/**
 * The land under a package's sight profile (ADR-053): its height map at every cell's centre, as the
 * headset stands a model on it (package-world.ts) -- flat on the floor, the grid's land beyond it
 * (and its edge's height past the grid). The API keeps it in the package's measurement (`WorldMeasure.ground`).
 */
export function heightsGround(grid) {
    return sightGround((x, z) => (Math.hypot(x, z) <= STAGE.floor ? 0 : heightAt(grid, x, z)));
}
//# sourceMappingURL=sight.js.map